import { apiClient, type PageData } from './client'

export type PromotionBundleStatus = 'enabled' | 'disabled'

export interface PromotionBundleItem {
  id: number
  bundle_id: number
  crmeb_product_id: number
  sku_unique: string
  product_name_snapshot: string
  sku_name_snapshot: string
  product_image_snapshot: string
  unit_price_snapshot: number
  quantity: number
  line_original_price: number
  sort: number
}

export interface PromotionBundle {
  id: number
  name: string
  description: string
  original_price: number
  promotion_price: number
  status: PromotionBundleStatus
  sort: number
  items?: PromotionBundleItem[]
  created_at: number
  updated_at: number
}

export interface PromotionBundleSavePayload {
  name: string
  description: string
  promotion_price: number
  status: PromotionBundleStatus
  sort: number
  items: Array<{
    product_id: number
    sku_unique: string
    quantity: number
    sort: number
  }>
}

export const promotionBundlesApi = {
  list: async (params: { keyword?: string; status?: string; page?: number; page_size?: number }) => {
    const search = new URLSearchParams()
    if (params.keyword) search.set('keyword', params.keyword)
    if (params.status) search.set('status', params.status)
    search.set('page', String(params.page ?? 1))
    search.set('page_size', String(params.page_size ?? 30))
    const response = await apiClient.get<PageData<PromotionBundle>>(`/settings/promotion-bundles?${search}`)
    return response.data
  },

  select: async (keyword: string, page = 1, pageSize = 30) => {
    const search = new URLSearchParams({ keyword, page: String(page), page_size: String(pageSize) })
    const response = await apiClient.get<PageData<PromotionBundle>>(`/settings/promotion-bundles/select?${search}`)
    return response.data
  },

  get: async (id: number) => {
    const response = await apiClient.get<PromotionBundle>(`/settings/promotion-bundles/${id}`)
    return response.data
  },

  create: async (payload: PromotionBundleSavePayload) => {
    const response = await apiClient.post<PromotionBundle>('/settings/promotion-bundles', payload)
    return response.data
  },

  update: async (id: number, payload: PromotionBundleSavePayload) => {
    const response = await apiClient.put<PromotionBundle>(`/settings/promotion-bundles/${id}`, payload)
    return response.data
  },

  delete: async (id: number) => {
    await apiClient.delete(`/settings/promotion-bundles/${id}`)
  },
}
